import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useCheckoutStoreContext } from '../../context';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

const CheckoutZones: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  useEffect(() => {
    checkoutStore.prepareZones();
  }, []);

  if (!checkoutStore.isDraft && !checkoutStore.selectedZone?.label) {
    return <></>;
  }

  const onSelectZone = async (option: IPickerOption[]) => {
    if (!option[0]) {
      return;
    }
    checkoutStore.selectZone(option[0]);
  };

  return (
    <div className="d-flex align-items-center mb-4">
      <Text type={TEXT.ORDER_FIELD} text="cc_delivery_zones_dropdown" />
      {checkoutStore.isDraft ? (
        <Picker
          className="checkout-zones"
          inputClassName="checkout-zones"
          listClassName="checkout-zones"
          placeholder="cc_select_delivery_zone"
          selectedOptions={checkoutStore.selectedZone ? [checkoutStore.selectedZone] : []}
          options={checkoutStore.zonesOptions}
          onSelect={onSelectZone}
          numberVisibleOptionsInDropdown={8}
          hideResetIcon
          searchable
          loading={checkoutStore.zonesLoading}
        />
      ) : (
        <p className="family-medium color-dark text-size-16 font-weight-500">{checkoutStore.selectedZone?.label}</p>
      )}
    </div>
  );
});

export default CheckoutZones;
